import React, { useCallback } from 'react';
import Form from 'react-bootstrap/Form';

const BaseForm = React.forwardRef(function (
  { form, className, onSubmit, children, ...props },
  ref
) {
  const handleSubmit = useCallback(
    (event) => {
      if (!form.validate(event)) return;
      if (onSubmit) onSubmit(form.values);
    },
    [form.values, onSubmit]
  );

  return (
    <Form
      {...props}
      ref={ref}
      noValidate
      validated={form.validated}
      className={className}
      onSubmit={handleSubmit}>
      {children}
    </Form>
  );
});

export default BaseForm;
